var slugify = require('slugify');

export const make_id_by_title = title => {
  return slugify(title);
};
